module.exports = __webpack_public_path__ + "img/ico-help.f9888622.svg";